import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import AccountSelection from './Component';
import actions from './actions';
import selectors from './selectors';
import checkOutSummarySelectors from '../../components/CheckOutSummary/selectors';

const mapStateToProps: any = createSelector(
  selectors.selectAccounts,
  selectors.selectSupplierBuyerAssociation,
  selectors.selectSelectedAccount,
  checkOutSummarySelectors.selectCheckOut,
  (accounts, supplierBuyerAssociation, selectedAccount, checkOut) => ({
    accounts,
    supplierBuyerAssociation,
    selectedAccount,
    checkOut,
  })
);

const mapDispatchToProps: any = (dispatch: any) => bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AccountSelection);
